// src/drawing/tools/FieldRectangleTool.js
import { RectangleTool } from "./RectangleTool";
import proj4 from "proj4";
import { getUtmProj } from "../utils/projection";
import { getMidfieldLine } from "../utils/geometry";

export class FieldRectangleTool extends RectangleTool {
  finalizeRectangle() {
    const rect = super.finalizeRectangle();   // WGS84 lng/lat
    if (!rect) return null;

    // ── Project to UTM before computing the midline ───────────────────
    // getMidfieldLine compares edge lengths to pick the LONG pair. Doing
    // that in WGS84 lng/lat gives WRONG answers for north-south oriented
    // fields because 1° longitude ≠ 1° latitude in metres. At 52° N
    // (Germany), 1° lat = 111 km while 1° lng = 68 km, so a 100 m N-S
    // edge has a smaller lng/lat Euclidean length than a 70 m E-W edge —
    // the function then picks the SHORT side as "long" and the midline
    // ends up parallel to the long axis instead of orthogonal to it.
    // (Bug Philip reproduced multiple times on 2026-05-20 / 2026-05-21
    // on N-S oriented pitches like Rahmwerder Straße 11.)
    //
    // Projecting to UTM gives true metres, so the comparison is correct
    // for any field orientation. We project the midline endpoints back
    // to WGS84 for storage/rendering on the map.
    const wgs84 = "EPSG:4326";
    const utm = getUtmProj(rect[0]);
    const rectUtm = rect.map((p) => proj4(wgs84, utm, p));
    const midUtm = getMidfieldLine(rectUtm);
    const centerLine = midUtm
      ? midUtm.map((p) => proj4(utm, wgs84, p))
      : null;

    this.setGeometries((prev) => ({ ...prev, fieldRectangle: rect, fieldCenterLine: centerLine }));
    this.setWorkflowStep((prev) => prev + 1);

    return rect;
  }
}